import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserService } from '@origin8-web/core-ui/login/providers';
import { SUPERVISR_ORGANIZATION } from '@origin8-web/models/core-business';
import { map, Observable } from 'rxjs';
import { UNAUTHORIZED_FULL_PATH } from '../../app.interface';

export const canActivateOrganization: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<true | UrlTree> => {
  const userService = inject(UserService);
  const router = inject(Router);
  return userService.getUser$().pipe(
    map((user) => {
      if (user?.organization === route.params['organization'] || user?.organization === SUPERVISR_ORGANIZATION) {
        return true;
      }
      return router.parseUrl(UNAUTHORIZED_FULL_PATH);
    }),
  );
};
